<template>
  <div class="">
    <div class="nav-top">
      <div class="box">
        <p><i class="el-icon-s-custom"></i> 欢迎来到河南省水土保持！</p>
        <p>{{ nowTime }}</p>
      </div>
    </div>
    <div class="clear"></div>
    <div class="search-box">
      <div class="box relative">
        <img class="absolute titleLogo" src="../../assets/title_logo.png" alt="" />
        <div class="search  absolute">
          <form action="" method="post" name="searchform" onSubmit="return false">
            <input name="keyboard" v-model="searchContent" class="input_text" @keyup.enter="showSearchPage"
              autocomplete="off" placeholder="" type="text" />
            <img class="searchBotton" src="../../assets/images/search.png" alt="" @click="showSearchPage" />
          </form>
        </div>
      </div>
    </div>
    <div class="nav-box" style="margin-top:48px">
      <div class="box">
        <ul>
          <li @click="menClick(0)" :index="0" :class="$route.meta.index == 0 ? 'active' : ''">
            <router-link to="/">首页</router-link>
          </li>
          <div></div>
          <li @click="menClick(1)" :index="1" :class="$route.meta.index == 1 ? 'active' : ''">
            <router-link to="/newIndex">水保新闻</router-link>
          </li>
          <div style=""></div>
          <li @click="menClick(2)" :index="2" @mouseover="showSubMenu = true" @mouseleave="showSubMenu = false"
            :class="{ active: $route.meta.index == 2 }" class="bulletin-board"><router-link
              to="/noticeIndex">公告栏</router-link>
            <ul v-show="showSubMenu"  class="sub-menu">
              <li><router-link to="/bulletinIndex">水保公报</router-link></li>
            </ul>
          </li>
          <div></div>
          <li @click="menClick(5)" :index="5" :class="$route.meta.index == 5 ? 'active' : ''">
            <router-link to="/monitoringIndex">监督监测</router-link>
          </li>
          <!-- <li @click="menClick(3)" :index="3" :class="$route.meta.index == 3 ?'active':''"><router-link to="/supervisionIndex" >监督监测</router-link></li> -->
          <div></div>
          <li @click="menClick(4)" :index="4" :class="$route.meta.index == 4 ? 'active' : ''">
            <router-link to="/comprehensiveControlIndex">综合治理</router-link>
          </li>
          <div></div>
          <!-- <li @click="menClick(5)" :index="5" :class="$route.meta.index == 5 ?'active':''"><router-link to="/monitoringIndex" >监测管理</router-link></li> -->
          <li @click="menClick(9)" :index="7" :class="$route.meta.index == 9 ? 'active' : ''">
            <router-link to="/creditManagementIndex">信用管理</router-link>
          </li>
          <div></div>
          <li @click="menClick(6)" :index="6" :class="$route.meta.index == 6 ? 'active' : ''">
            <router-link to="/policiesAndRegulationsIndex">政策法规</router-link>
          </li>
          <!-- <li @click="menClick(8)" :index="8" :class="$route.meta.index == 8 ?'active':''"><router-link to="/popularScienceKnowledgeIndex" >科普知识</router-link></li>
                    <li v-if="false" @click="menClick(7)" :index="7" :class="$route.meta.index == 7 ?'active':''"><router-link to="/institutionalFunctionIndex" >机构职能</router-link></li> -->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {},
  data() {
    return {
      searchContent: null,
      activeIndex: 0,
      isMinScreen: this.$root.$data.isMinScreen,
      nowTime: null,
      showSubMenu: false,
    };
  },
  created() {
    setInterval(() => {
      this.setNowTimes();
    }, 1000);
  },
  watch: {
    //监听是否是小窗口界面
    "$root.$data.isMinScreen": function (val) {
      if (typeof val === "boolean") {
        this.isMinScreen = val;
      }
      //非小屏幕
      if (!val) {
        document.getElementsByClassName("nav-menu-box").item(0).style.display =
          "block";
        let listSubList = document.querySelectorAll(".start-list-sub");
        listSubList.forEach(function (v) {
          v.removeAttribute("style");
        });
      }
    }
  },
  methods: {
    setNowTimes() {
      let year = new Date().getFullYear();
      let month =
        new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1;
      let date =
        new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate();
      let hh =
        new Date().getHours() < 10
          ? "0" + new Date().getHours()
          : new Date().getHours();
      let mm =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      this.nowTime =
        year + "-" + month + "-" + date + " " + hh + ":" + mm + ":" + ss;
    },
    menClick(index) {
      this.activeIndex = index;
    },
    //小窗口菜单显示逻辑
    showMobileNav() {
      let navDom = document.getElementsByClassName("nav-menu-box").item(0);
      navDom.style.display =
        !navDom.style.display || navDom.style.display === "none"
          ? "block"
          : "none";
    },
    subNavOpen(e) {
      let listSubList = document.querySelectorAll(".start-list-sub");
      listSubList.forEach(function (v) {
        if (v === e.currentTarget.previousElementSibling) {
          v.style.display = v.style.display === "block" ? "none" : "block";
        } else {
          v.style.display = "none";
        }
      });
      //document.getElementsByClassName('nav-menu-box').item(0).style.display = 'none'
    },
    //菜单点击原生事件
    navMenuClick() {
      if (this.isMinScreen) {
        document.getElementsByClassName("nav-menu-box").item(0).style.display =
          "none";
      }
    },
    //搜索页面
    showSearchPage() {
      this.$router.push({
        path: "/searchIndex",
        query: {
          searchContent: this.searchContent
        }
      });
    }
  }
};
</script>
<style scoped>
.nav-box ul div {
  margin-top: 10px;
  float: left;
  width: 1px;
  height: 30px;
  border-right: 1px dashed #fff;
}


.bulletin-board {
  position: relative;
}

.sub-menu {
  position: absolute;
  left: 0;
  top: 100%;
  /* background-color: #fff; */
  text-align: center;
  cursor: pointer;
  z-index: 999;
}
.sub-menu a {
  padding: 0 2px;
}


.sub-menu li {
  display: block;
}

.active {
  /* 激活状态的样式 */
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Header.vue